import List from "@/components/list";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "班组名称",
      prop: "groupName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "120"
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120"
    },
    {
      label: "职称",
      prop: "positionLevelName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "考勤时间",
      prop: "clockTime",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "考勤状态",
      prop: "clockResultName",
      minWidth: "120",
      showOverflowTooltip: true
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
